import React from 'react'
import { Button, Group, LoadingOverlay, Modal, Text } from "@mantine/core"
import { PromoteMode } from '../../GlobalJobMatchingVersioning/types/versions'
import { modeText } from './TitleBar'

type ApplyRulesModalProps = {
  opened: boolean
  onClose: () => void
  mode: PromoteMode
  applyRules: (mode: PromoteMode) => void
  isApplyingRules: boolean
}

export const ApplyRulesModal = ({ opened, onClose, mode, applyRules, isApplyingRules }: ApplyRulesModalProps) => {
  return (
    <Modal title='Confirm Apply' size='xl' opened={opened} onClose={onClose}>
      <LoadingOverlay visible={isApplyingRules} />
      <Text>You have selected to <Text span fw='bold'>"{modeText[mode]}".</Text> Please confirm your choice, or cancel and return to the page.</Text>
      <Group justify='flex-end' mt='xl'>
        <Button size='lg' variant='outline' onClick={onClose}>Cancel</Button>
        <Button size='lg' onClick={() => applyRules(mode)}>Apply</Button>
      </Group>
    </Modal>
  )
}
